import React from 'react';
import FeedPicture from './FeedPicture.jsx';
import FeedText from './FeedText.jsx';
import ContentMeta from '../ContentMeta.jsx';
import Thumbnail from '../Thumbnail.jsx';
import ArticleLink from '../ArticleLink.jsx';
import _ from 'lodash';

export default class FeedContainerSmall extends React.PureComponent {
  onClick(event) {
    const { onClick, contentContainer } = this.props;

    if (onClick) {
      event.preventDefault();
      onClick(contentContainer);
    }
  }

  render() {
    const { contentContainer, useVideoTypeTags, customTags, smallRibbon, isCurrentlyPlayed } = this.props;
    if (_.isEmpty(contentContainer)) return null;

    return (
      <div className="feed-container feed-container-small">
        <Thumbnail isCurrentlyPlayed={isCurrentlyPlayed} smallRibbon={smallRibbon} className="thumbnail-small" data={contentContainer} maxItems={2}>
          <ArticleLink onClick={this.onClick.bind(this)} contentContainer={contentContainer}>
            <FeedPicture contentContainer={contentContainer} size={3}/>
          </ArticleLink>
        </Thumbnail>
        <ContentMeta data={contentContainer} noTimestamp useVideoTypeTags={useVideoTypeTags} customTags={customTags} />
        <h4>
          <ArticleLink onClick={this.onClick.bind(this)} contentContainer={contentContainer}>
            <FeedText contentContainer={contentContainer} />
          </ArticleLink>
        </h4>
      </div>
    );
  }
}

FeedContainerSmall.propTypes = {
  contentContainer: React.PropTypes.object.isRequired,
  contentType: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeedContainerSmall.jsx